export const MUI_LICENSE_KEY =
    '0fd74136bd94b13abc451b7bc4cbd33fTz0xMzAyOTEsRT0xODE3NTk2Nzk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9aW5pdGlhbCxLVj0y';
